import { email, ValidationRule } from 'vuelidate/lib/validators';

// eslint-disable-next-line import/prefer-default-export
export const emailWithUppercase = (mail: string): boolean => {
  if (!mail) {
    return true;
  }

  const checkEmail = (email as unknown as ValidationRule);

  return checkEmail(mail.toLowerCase());
};
